import { useEffect } from 'react';
import { isEqual } from 'lodash-es';
import type {
  DomainEntity,
  EntityDetail,
  EntityDetailSchema,
  EntityRootData,
} from '@web-config-app/core';
import { useDataSourceStore } from '../../state/data-source/data-source-store-provider';
import { getSchemaDataSources } from '../../utils/get-schema-data-sources/get-schema-data-sources';

/**
 * Listens for changes to the root schema and data and updates any registered data sources
 * accordingly.
 */

export const useSyncDataSources = (
  schema: EntityDetailSchema,
  data: EntityRootData | undefined,
  includedEntities?: EntityDetail[],
  domainEntity?: DomainEntity,
) => {
  const store = useDataSourceStore();
  const isEntityUsingConfigAppBackend = domainEntity?.isUsingConfigAppBackend;

  useEffect(() => {
    const schemaDataSources = getSchemaDataSources(
      schema,
      data,
      includedEntities,
      isEntityUsingConfigAppBackend,
    );

    const { dataSources, setDataSource, setDataSourceValue } = store.getState();
    schemaDataSources.forEach((schemaDataSource) => {
      const previousDataSourceValue = dataSources?.get(
        schemaDataSource.name,
      )?.value;
      if (!previousDataSourceValue) {
        setDataSource(schemaDataSource);
      } else if (
        schemaDataSource &&
        !isEqual(schemaDataSource.value, previousDataSourceValue)
      ) {
        setDataSourceValue(schemaDataSource.name, schemaDataSource.value);
      }
    });
  }, [data, schema, store, includedEntities, isEntityUsingConfigAppBackend]);
};
